import { CreateReminderChannelCards } from './create-reminder-channel-cards';
import { TemplatesDropdown } from '@src/shared/features/reminders/dialogs/create-or-edit-reminder/templates-dropdown';
import { AttachmentsField } from '@src/shared/features/reminders/attachments-field';
import { SubjectField } from '@src/shared/features/reminders/subject-field';

type CreateReminderDetailsSectionProps = {
  title?: string;
};

export function CreateReminderDetailsSection({
  title = '2. Reminder Details',
}: CreateReminderDetailsSectionProps = {}) {
  return (
    <section className='rounded-xl border border-[#E8E7F0] bg-white p-4'>
      <p className='mb-4 text-sm font-semibold text-gray-500'>{title}</p>

      <div className='flex flex-col gap-4'>
        <CreateReminderChannelCards />
        <TemplatesDropdown />
        <SubjectField />
        <AttachmentsField />
      </div>
    </section>
  );
}
